

<template lang='pug'>
 .tab-container
        van-tabs(v-model="active")
            van-tab(title="内容收藏")
                .content 
                    .line
                .content-box
                    .product-container
                        Product.item(v-for="(item,index) in contentData" :key="index" :img="item.imga" :bigName="item.bigName" :smallName="item.smallName" :name="item.name" :params="item.params")
            van-tab(title="资料收藏")
                .content 
                    .line
                .content-box
                    .information-list
                        //- InformationDownload.info(name="如东如东如东",link="https://www.baidu.com" )
                        InformationDownload.info(v-for="(item,index) in dataData" :key="index" :name="item.name" :link="item.link")
                        
            van-tab(title="直播收藏")
                .content 
                    .line
                .content-box
                    .live-container
                        Class(v-for="(item,index) in liveData" :key="index" :title="item.name" cut="类型" :time="item.time" cutContent="预约直播" :img="item.img" type='查看')
</template>

<script>
import Product from './product'
import Class from './class'
import InformationDownload from './informationDownload'
import { mapState } from 'vuex'
export default {

data(){
    return {
        active:0,
        contentData:[],
        dataData:[],
        liveData:[],
        from:''
    }
},
    async created() {
        this.contentData=[],
        this.dataData=[],
        this.liveData=[]
             this.bookMarks.forEach(val=>{
            if(val.detail.type=='content'){
                this.contentData.push(val.detail)
            }else if(val.detail.type=='data'){
                this.dataData.push(val.detail)
            }else{
                this.liveData.push(val.detail)
            }
        })
    },
     components:{
        InformationDownload,Product,Class
    },
    computed:{
          ...mapState(['memberInfo','userInfo','bookMarks','bookMarksLoading']) 
    }
}
</script>

<style scoped lang='less'>
 /deep/.van-tab--active{
    color: #07448a;
}
/deep/.van-icon-cross::before{
    color:black
}

/deep/.van-tabs__wrap{
    padding-left:1rem;
    padding-right: 1rem;
     height:1.5rem
}
/deep/.van-tabs__line{
     background: #07448a;
}
/deep/.van-tab{
    flex:none;
    padding:0;
}
/deep/.van-tabs__nav{
    justify-content: space-between
}
/deep/.van-tabs__line{
    width:17%;
    height:0.1rem;
}
.line{
    position: absolute;
    width: 100%;;
    height: 0.1rem;
    background: #f3f3f3;
    top:-0.1rem;
}
.content{
    position: relative;
}
.collection-container {
    .tab-container{
        .content-box{
            padding:1rem 1rem 3rem 1rem;
            .info{
                margin-bottom:0.6rem;
            }
            .item{
                margin-bottom: 0.6rem;
            }
        }
    }
   
}
</style>